import {Dialog} from '@progress/kendo-react-dialogs'

export const TermsModal = ({show, onClose}: {show: boolean; onClose: () => void}) => {
  if (!show) return null

  return (
    <Dialog
      style={{backgroundColor: 'rgba(0,0,0,0.45)'}}
      title={'Terms of Use'}
      onClose={onClose}
      width={'50%'}
      height={'70%'}
    >
      <div className='row mb-4 p-6'>
        <h2>Terms of Use</h2>
        <p>Your terms of use here...</p>
        <p>
          Lorem ipsum dolor sit amet, cu vix dico case, oporteat sensibus iracundia ea eam. No
          habemus lucilius sit, an copiosae complectitur qui. Quodsi albucius id nec, vel dicam
          integre malorum in, ea vel mucius constituto definiebas. An duo dico denique inciderint.
          Ei est amet neglegentur conclusionemque. No sit scripta alterum, clita propriae no nec.
          Meliore conceptam at sed, mel ne amet tincidunt scripserit, ad pro dolorem invidunt
          iracundia. Vix id causae disputando. Ei mel prima facer doming. Graeci regione deleniti ad
          sed. Vero prima ea duo, an pro dicunt adipiscing voluptatibus. Per ex repudiare splendide,
          mei solet maluisset at, cu copiosae adversarium sed. Mel cu apeirian disputationi, no
          posidonium quaerendum sea. Ne pro nibh sensibus facilisis, phaedrum torquatos ius ut, esse
          delectus mediocrem ea nec. Mei menandri molestiae scriptorem ut, solet numquam eu has. Quo
          animal apeirian consequuntur an. In mel erat idque signiferumque, an mei error apeirian
          necessitatibus, eu ius falli nostrum atomorum. Sit nonumy menandri tractatos eu. Usu no
          sint evertitur, vix semper verterem phaedrum ei, sed facilis quaestio expetenda cu. No
          euismod conceptam has, choro invenire delicata eu ius, id mei solet dictas. Gloriatur
          intellegebat et vix. Viris iudico eam no, esse bonorum sed no, eligendi honestatis eum cu.
          Eu cum altera aliquid torquatos. Ut nec quod imperdiet, quo ne unum iudico bonorum. Vim ea
          tota laudem saperet. Et duo delenit noluisse similique, id cum aeterno phaedrum
          voluptatibus.
        </p>
        <p>
          Lorem ipsum dolor sit amet, cu vix dico case, oporteat sensibus iracundia ea eam. No
          habemus lucilius sit, an copiosae complectitur qui. Quodsi albucius id nec, vel dicam
          integre malorum in, ea vel mucius constituto definiebas. An duo dico denique inciderint.
          Ei est amet neglegentur conclusionemque. No sit scripta alterum, clita propriae no nec.
          Meliore conceptam at sed, mel ne amet tincidunt scripserit, ad pro dolorem invidunt
          iracundia. Vix id causae disputando. Ei mel prima facer doming. Graeci regione deleniti ad
          sed. Vero prima ea duo, an pro dicunt adipiscing voluptatibus. Per ex repudiare splendide,
          mei solet maluisset at, cu copiosae adversarium sed. Mel cu apeirian disputationi, no
          posidonium quaerendum sea. Ne pro nibh sensibus facilisis, phaedrum torquatos ius ut, esse
          delectus mediocrem ea nec. Mei menandri molestiae scriptorem ut, solet numquam eu has. Quo
          animal apeirian consequuntur an. In mel erat idque signiferumque, an mei error apeirian
          necessitatibus, eu ius falli nostrum atomorum. Sit nonumy menandri tractatos eu. Usu no
          sint evertitur, vix semper verterem phaedrum ei, sed facilis quaestio expetenda cu. No
          euismod conceptam has, choro invenire delicata eu ius, id mei solet dictas. Gloriatur
          intellegebat et vix. Viris iudico eam no, esse bonorum sed no, eligendi honestatis eum cu.
          Eu cum altera aliquid torquatos. Ut nec quod imperdiet, quo ne unum iudico bonorum. Vim ea
          tota laudem saperet. Et duo delenit noluisse similique, id cum aeterno phaedrum
          voluptatibus.
        </p>
        <p>
          Lorem ipsum dolor sit amet, cu vix dico case, oporteat sensibus iracundia ea eam. No
          habemus lucilius sit, an copiosae complectitur qui. Quodsi albucius id nec, vel dicam
          integre malorum in, ea vel mucius constituto definiebas. An duo dico denique inciderint.
          Ei est amet neglegentur conclusionemque. No sit scripta alterum, clita propriae no nec.
          Meliore conceptam at sed, mel ne amet tincidunt scripserit, ad pro dolorem invidunt
          iracundia. Vix id causae disputando. Ei mel prima facer doming. Graeci regione deleniti ad
          sed. Vero prima ea duo, an pro dicunt adipiscing voluptatibus. Per ex repudiare splendide,
          mei solet maluisset at, cu copiosae adversarium sed. Mel cu apeirian disputationi, no
          posidonium quaerendum sea. Ne pro nibh sensibus facilisis, phaedrum torquatos ius ut, esse
          delectus mediocrem ea nec. Mei menandri molestiae scriptorem ut, solet numquam eu has. Quo
          animal apeirian consequuntur an. In mel erat idque signiferumque, an mei error apeirian
          necessitatibus, eu ius falli nostrum atomorum. Sit nonumy menandri tractatos eu. Usu no
          sint evertitur, vix semper verterem phaedrum ei, sed facilis quaestio expetenda cu. No
          euismod conceptam has, choro invenire delicata eu ius, id mei solet dictas. Gloriatur
          intellegebat et vix. Viris iudico eam no, esse bonorum sed no, eligendi honestatis eum cu.
          Eu cum altera aliquid torquatos. Ut nec quod imperdiet, quo ne unum iudico bonorum. Vim ea
          tota laudem saperet. Et duo delenit noluisse similique, id cum aeterno phaedrum
          voluptatibus.
        </p>{' '}
        <p>
          Lorem ipsum dolor sit amet, cu vix dico case, oporteat sensibus iracundia ea eam. No
          habemus lucilius sit, an copiosae complectitur qui. Quodsi albucius id nec, vel dicam
          integre malorum in, ea vel mucius constituto definiebas. An duo dico denique inciderint.
          Ei est amet neglegentur conclusionemque. No sit scripta alterum, clita propriae no nec.
          Meliore conceptam at sed, mel ne amet tincidunt scripserit, ad pro dolorem invidunt
          iracundia. Vix id causae disputando. Ei mel prima facer doming. Graeci regione deleniti ad
          sed. Vero prima ea duo, an pro dicunt adipiscing voluptatibus. Per ex repudiare splendide,
          mei solet maluisset at, cu copiosae adversarium sed. Mel cu apeirian disputationi, no
          posidonium quaerendum sea. Ne pro nibh sensibus facilisis, phaedrum torquatos ius ut, esse
          delectus mediocrem ea nec. Mei menandri molestiae scriptorem ut, solet numquam eu has. Quo
          animal apeirian consequuntur an. In mel erat idque signiferumque, an mei error apeirian
          necessitatibus, eu ius falli nostrum atomorum. Sit nonumy menandri tractatos eu. Usu no
          sint evertitur, vix semper verterem phaedrum ei, sed facilis quaestio expetenda cu. No
          euismod conceptam has, choro invenire delicata eu ius, id mei solet dictas. Gloriatur
          intellegebat et vix. Viris iudico eam no, esse bonorum sed no, eligendi honestatis eum cu.
          Eu cum altera aliquid torquatos. Ut nec quod imperdiet, quo ne unum iudico bonorum. Vim ea
          tota laudem saperet. Et duo delenit noluisse similique, id cum aeterno phaedrum
          voluptatibus.
        </p>
        <p>
          Lorem ipsum dolor sit amet, cu vix dico case, oporteat sensibus iracundia ea eam. No
          habemus lucilius sit, an copiosae complectitur qui. Quodsi albucius id nec, vel dicam
          integre malorum in, ea vel mucius constituto definiebas. An duo dico denique inciderint.
          Ei est amet neglegentur conclusionemque. No sit scripta alterum, clita propriae no nec.
          Meliore conceptam at sed, mel ne amet tincidunt scripserit, ad pro dolorem invidunt
          iracundia. Vix id causae disputando. Ei mel prima facer doming. Graeci regione deleniti ad
          sed. Vero prima ea duo, an pro dicunt adipiscing voluptatibus. Per ex repudiare splendide,
          mei solet maluisset at, cu copiosae adversarium sed. Mel cu apeirian disputationi, no
          posidonium quaerendum sea. Ne pro nibh sensibus facilisis, phaedrum torquatos ius ut, esse
          delectus mediocrem ea nec. Mei menandri molestiae scriptorem ut, solet numquam eu has. Quo
          animal apeirian consequuntur an. In mel erat idque signiferumque, an mei error apeirian
          necessitatibus, eu ius falli nostrum atomorum. Sit nonumy menandri tractatos eu. Usu no
          sint evertitur, vix semper verterem phaedrum ei, sed facilis quaestio expetenda cu. No
          euismod conceptam has, choro invenire delicata eu ius, id mei solet dictas. Gloriatur
          intellegebat et vix. Viris iudico eam no, esse bonorum sed no, eligendi honestatis eum cu.
          Eu cum altera aliquid torquatos. Ut nec quod imperdiet, quo ne unum iudico bonorum. Vim ea
          tota laudem saperet. Et duo delenit noluisse similique, id cum aeterno phaedrum
          voluptatibus.
        </p>
        <button className='btn fw-bold py-2 px-3 rounded-pill btn-doora' onClick={onClose}>
          Close
        </button>
      </div>
    </Dialog>
  )
}
